<ng-container *transloco="let t">

  <form id="inputForm" *ngIf="inputForm$ | async as inputForm" [formGroup]="inputForm" (ngSubmit)="submit(inputForm)">
    <div class="row w-100 m-0 justify-content-center">
      <div class="col-12 col-sm-8 col-md-6">
        <div class="row">
          <ng-container *ngFor="let frmGrp of arrayFrmGrp$ | async; index as i" formArrayName="values">
            <ng-container [formGroupName]="i">
              <div class="col-8 text-justify border p-0-5">
                <span class="d-block aling-self-center">{{frmGrp.get('question')?.value}}</span>
              </div>
              <div class="border col-4  p-0">
                <mat-button-toggle-group formControlName="answer" class="w-100 h-100">
                  <mat-button-toggle value="false" #no
                    class="w-50 aling-self-center warn-important {{no.checked ? 'selected' : ''}}">
                    {{t('common.no')}}
                  </mat-button-toggle>
                  <mat-button-toggle value="true" #yes
                    class="w-50 aling-self-center accent-important {{yes.checked ? 'selected' : ''}}">
                    {{t('common.yes')}}
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </form>

</ng-container>
